module.exports = __webpack_public_path__ + "img/oph.dda1a355.svg";